import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "@/pages/Landing";
import Admin from "@/pages/Admin";
import { Toaster } from "sonner";

export default function App() {
  return (
    <div className="App font-sans" dir="rtl" lang="ar">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="top-center"
        richColors
        dir="rtl"
        toastOptions={{
          style: { fontFamily: "Readex Pro, sans-serif", textAlign: "right" },
        }}
      />
    </div>
  );
}
